
import LoadingIcon from './loading-icon/LoadingIcon.vue'

export default app => {
  app.component('LoadingIcon', LoadingIcon)

}
